import { FormControl, InputLabel } from "@mui/material";
import React, { FC, ReactNode } from "react";

export interface InputInfoProperties {
    label?: ReactNode;
    text?: ReactNode;
    className?: string;
}

const InputInfo: FC<InputInfoProperties> = ({
    label = "",
    text = "",
    className = "",
}) => {
    return <>
        <FormControl size={"small"} fullWidth margin="dense">
            <InputLabel shrink={label !== ""} className={className} style={{ left: -14 }}>
                <strong>{label}</strong>
            </InputLabel>
            <p className="p-info" style={{ textAlign: "left", marginTop: 8 }}>{text}</p>
        </FormControl>
    </>
}

export { InputInfo } 